<template>
  <div class="index text-sm text-blueGray-800">
    <!-- this will be only place to make a new course. place all contents of mixin into this component -->
    <new-course-modal
      v-if="show_create_course_modal"
      @createCourse="createCourse"
      @close="show_create_course_modal = false"
      @courseCreated="show_course_created_modal = true"
    />
    <join-roundtable-modal
      v-if="show_join_roundtable_modal"
      @joinRoundtable="joinRoundtable"
      @modalClosed="show_join_roundtable_modal = false"
    />
    <!-- Only load the main component (the app) when the user information is finished loading -->
    <choose-role
      v-if="getProfile.role === 'guest' && !getProfile.loading"
      style="
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
      "
      @role="chooseRole"
    />
    <template v-else>
      <router-view v-if="!getProfile.loading" name="dashboard" />
      <router-view :key="$store.state.isReloadComponent"></router-view>
    </template>
    <div ref="toastContainer" class="fixed z-50 top-1 right-2 w-96">
      <pl-toast
        v-if="toast_show == 'true'"
        :toastType="'Info'"
        :toastMessage="toastMessage"
        @close="removeInfo"
      />
    </div>
    <div
      v-if="
        isOpenToastDemo === true &&
        ($route.params.roundtableID ===
          'a1f7390a-de1a-44a9-a8cf-370782a147f8' ||
          $route.params.liveDiscussionID ===
            'cf323be5-f772-415f-b336-fbf194d6a203' ||
          $route.params.courseID === $store.state.course_sample_id)
      "
      ref="toastContainers"
      class="fixed bg-sky-400 hover:bg-sky-500 z-50 top-1 right-2. w-96"
    >
      <div class="flex text-white rounded-sm w-full">
        <div class="left-0 px-1 py-3 w-11/12 flex items-center">
          <img
            src="../app/components/material/components/plToast/info.svg"
            class="text-2xl px-3"
          />
          <span class="text-sm justify-center items-center"
            >Hey! This is just a demo!</span
          >
        </div>
        <div class="flex justify-center">
          <button @click="isOpenToastDemo = false">
            <i class="fas fa-times text-white" />
          </button>
        </div>
      </div>
    </div>

    <!-- Special tost for signup error - TEMPORARY -->

    <!-- Global Alert - gets fired through the event bus -->
    <div
      id="alert-message"
      class="row nowrap middle-xs between-xs"
      :class="{ active: alert_show }"
    >
      <span style="margin-left: 20px" class="">
        <strong><i>WARNING!</i></strong>
        <br />
        {{ alert_message }}
      </span>
      <pl-button
        @click.native="alert_show = false"
        style="color: #fff; margin: 0"
        >CLOSE</pl-button
      >
    </div>

    <upgrade-modal
      v-if="show_upgrade_modal"
      :text="text"
      :studentReport="studentReport"
      @close="show_upgrade_modal = false"
    />

    <!-- Upgrade Success Modal - fired when a teacher Successfully upgrades -->
    <upgrade-success-modal
      @closeModal="show_upgrade_success_modal = false"
      v-if="show_upgrade_success_modal"
    />

    <upgrade-block-modal
      @closeModal="show_block_upgrade_modal = false"
      v-if="show_block_upgrade_modal"
      :adminUsersOfSchool="adminUsersOfSchool"
    />

    <email-suffix-block-modal
      @closeModal="show_email_suffix_block_modal = false"
      v-if="show_email_suffix_block_modal"
      :emailSuffixesOfSchool="emailSuffixesOfSchool"
    />

    <role-changed-modal
      v-if="show_role_changed_modal"
      @closeModal="show_role_changed_modal = false"
    />

    <removed-student-from-school-modal
      v-if="show_removed_student_from_school_modal"
      @closeModal="show_removed_student_from_school_modal = false"
      :deleteCourse="deleteCourse"
    />
    <school-courses-modal
      v-if="show_school_courses_modal"
      :header="header"
      :school="upgraded_school"
      :showUpgrade="true"
      @closeModal="show_school_courses_modal = false"
    />
    <integrations-connect-account-modal
      v-if="show_connect_integration_account_modal"
      :selectedIntegration="account_integration"
      @close="show_connect_integration_account_modal = false"
    />
    <course-created-modal
      v-if="show_course_created_modal"
      @close="show_course_created_modal = false"
    />
    <pl-dialog
      :disableOutsideClick="true"
      v-if="show_membership_invalid_modal"
      @close="closeInvalidMembershipModal"
      style="padding: 25px"
      maxWidth="700px"
    >
      <pl-button
        @click.native="closeInvalidMembershipModal"
        style="position: absolute; top: 0; right: 0"
        class="pl-icon"
      >
        <i class="fa fa-close"></i>
      </pl-button>
      <div class="flex justify-center pl-title ma pl-secondary mv3">
        <strong class="tc">Membership expired</strong>
      </div>
      <div class="flex justify-center items-center">
        <p
          class="pl-subheading tc mv4 pl-secondary"
          style="font-size: 18px; max-width: 600px"
        >
          It looks like your school's Parlay membership has expired. Please
          contact <b> annalisa@parlayideas.com</b> to learn more and update your
          membership.
        </p>
      </div>
    </pl-dialog>
    <Onboarding
      v-if="show_welcome_modal"
      @close="show_welcome_modal = false"
    />
    <ModalTeacherAfterSignUp
      v-if="isModalTeacherOpenAfterSignUp"
      @close="isModalTeacherOpenAfterSignUp = false"
    />
  </div>
</template>

<!-- JS logic -->
<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application
   */
  import Vue from 'vue';
  import store from './store';
  import { router } from '../bootstrap';
  import { mapGetters } from 'vuex';
  import { appLoadAsync } from './index.side-effects';
  import { EventBus } from 'utils/event-bus';
  import amplitude from 'amplitude-js';

  // Modals
  import upgradeModal from 'components/modals/upgradeModal';
  import upgradeSuccessModal from 'components/upgradeSuccessModal/upgradeSuccessModal';
  import NewCourseModal from 'features/courses/components/newCourseModal.vue';
  import SchoolCoursesModal from 'features/courses/components/schoolCoursesModal';
  import JoinRoundtableModal from 'features/courses/components/joinRoundtableModal.vue';
  import upgradeBlockModal from 'components/modals/upgradeBlockModalViews/upgradeBlockModal';
  import emailSuffixBlockModal from 'components/modals/upgradeBlockModalViews/emailSuffixBlockModal';
  import roleChangedModal from 'components/modals/roleChangedModal.vue';
  import RemovedStudentFromSchoolModal from './components/modals/removedStudentFromSchoolModal/removedStudentFromSchoolModal.vue';
  import integrationsConnectAccountModal from 'components/modals/integrationsConnectAccountModal';
  import CourseCreatedModal from 'features/courses/components/courseCreatedModal.vue';
  import Onboarding from './components/modals/Onboarding/Onboarding.vue';
  import ModalTeacherAfterSignUp from 'features/dashboard/ModalAfterSignUp.vue';

  import plToast from 'components/material/components/plToast/plToast.vue';

  import ChooseRole from 'components/chooseRole';

  // Socket Mixin
  import individualSocketEvents from 'mixins/sockets/individualSocketEvents';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';

  export default {
    mixins: [individualSocketEvents, courseSocketMixin],
    data() {
      return {
        show_upgrade_modal: false,
        show_upgrade_success_modal: false,
        toast_show: false,
        show_signup_error_toast: false,
        toast_message: '',
        alert_show: false,
        alert_message: '',
        show_school_courses_modal: false,
        show_create_course_modal: false,
        show_join_roundtable_modal: false,
        show_block_upgrade_modal: false,
        show_email_suffix_block_modal: false,
        upgraded_school: null,
        adminUsersOfSchool: [],
        emailSuffixesOfSchool: [],
        show_role_changed_modal: false,
        show_removed_student_from_school_modal: false,
        show_membership_invalid_modal: false,
        deleteCourse: false,
        account_integration: null,
        show_connect_integration_account_modal: false,
        show_course_created_modal: false,
        isMounted: false,
        isOpenToastDemo: false,
        text: '',
        studentReport: false,
        show_welcome_modal: false,
        isModalTeacherOpenAfterSignUp: false,
      };
    },
    components: {
      upgradeModal,
      upgradeSuccessModal,
      ChooseRole,
      NewCourseModal,
      SchoolCoursesModal,
      JoinRoundtableModal,
      upgradeBlockModal,
      emailSuffixBlockModal,
      roleChangedModal,
      RemovedStudentFromSchoolModal,
      integrationsConnectAccountModal,
      CourseCreatedModal,
      Onboarding,
      ModalTeacherAfterSignUp,
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourses']),
      header() {
        if (this.getProfile.school_info.school_id) {
          return `Now that you’re a part of ${this.getProfile.school_info.school_name}, we need to know which of your Parlay courses are also a part of that school.
          You can select archived courses and courses from previous years, but it’s not necessary.`;
        }
        return '';
      },
    },
    /**
     * The Vuex store
     */
    store,
    /**
     * The router
     */
    router,
    methods: {
      teacherOnlyRoute(routeName) {
        // is route only for teacher? boolean
        const teacherOnlyRoutes = ['roundtable.edit', 'live.edit'];
        return teacherOnlyRoutes.includes(routeName);
      },
      fireToast(msg) {
        this.toast_message = msg;
        this.toast_show = true;
        this.isOpenToastDemo = true;
        setTimeout(() => {
          this.toast_show = false;
        }, 5000);
      },
      createToast(toast) {
        var ComponentClass = Vue.extend(plToast);
        var instance = new ComponentClass({
          propsData: {
            toastMessage: toast.message,
            toastType: toast.type,
            toastTime: toast.time,
            notification: toast.notification,
            toastLink: toast.link,
            myPortfolio: toast.my_portfolio,
            newUi: toast.newUi,
            upgrade: toast.upgrade,
          },
        });
        instance.$mount();
        this.$refs.toastContainer.appendChild(instance.$el);
      },
      closeToast() {
        this.isVisible = false;
        this.toastType = '';
        this.toastMessage = '';
      },
      closeInvalidMembershipModal() {
        this.show_membership_invalid_modal = false;
        this.$router.push({ name: 'dashboard' });
      },
      chooseRole(role) {
        // make custom confirm
        const confirmed = confirm(`Are you sure you are a ${role}?`); // eslint-disable-line
        if (confirmed) {
          store
            .dispatch('updateRole', { id: this.getProfile.id, role })
            .then(() => {
              // set amplitude identity for role
              const identify = new amplitude.Identify();
              identify.set('role', role);
              amplitude.getInstance().identify(identify);
            });
        }
      },
      createCourse(newCoursePayload) {
        store
          .dispatch('createCourse', newCoursePayload)
          .then(() => {
            this.show_create_course_modal = false;
          })
          .catch(() => {
            this.fireToast('Course was not created. Try again');
          });
      },
      joinRoundtable: async function (payload) {
        await this.$store.dispatch('useInviteCode', payload.invite_code).then(() => {
          this.show_join_roundtable_modal = false;
        });
      },
      sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      async gradesGoogleSyncJob(payload) {
        const { jobID } = payload;
        if (jobID) {
          let state = '';
          do {
            await this.sleep(1000);
            const response = await this.$store.dispatch(
              'gradeClassroomStudentsStatus',
              payload
            );
            state = response.data.state;
          } while (state !== 'completed' && state !== 'failed');
          if (state === 'completed') {
            EventBus.$emit('toast-msg', 'Finished syncing grades');
          } else if (state === 'failed') {
            EventBus.$emit('toast-msg', 'Error syncing grades');
          }
        }
      },
      async gradesEdlinkSyncJob(payload) {
        const { jobID } = payload;
        if (jobID) {
          let state = '';
          do {
            await this.sleep(1000);
            const response = await this.$store.dispatch(
              'gradeEdlinkStudentsStatus',
              payload
            );
            state = response.data.state;
          } while (state !== 'completed' && state !== 'failed');
          if (state === 'completed') {
            EventBus.$emit('toast-msg', 'Finished syncing grades');
          } else if (state === 'failed') {
            EventBus.$emit('toast-msg', 'Error syncing grades');
          }
        }
      },
      // Function fires on user login
      initializeApp() {
        appLoadAsync.apply(this);
        setTimeout(() => {
          if (localStorage.getItem('schoolInfoPostUpgrade')) {
            this.show_upgrade_success_modal = true;
          }
          if (localStorage.getItem('showBlockUpgradeModal')) {
            this.show_block_upgrade_modal = true;
          }
          if (localStorage.getItem('showEmailSuffixesBlockModal')) {
            this.show_email_suffix_block_modal = true;
          }
        });
      },
      handleOpenModalTeacher: function () {
        setTimeout(() => {
          this.isModalTeacherOpenAfterSignUp = true;
        }, 1000);
      },
    },
    beforeCreate() {
      // This is to preserve google analytics data and not mess up the dashboard
      if (this.$route.params.redirect_from === 'corporate') {
        window.gtag('config', 'UA-90906114-1');
      }

      if (this.$store.state.auth.authenticated) {
        appLoadAsync.apply(this);
      }
    },
    created() {
      window.addEventListener('offline', () => {
        let buttons = document.getElementsByTagName('button');
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].disabled = true;
        }
      });

      window.addEventListener('online', () => {
        let buttons = document.getElementsByTagName('button');
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].disabled = false;
        }
      });
    },
    mounted() {
      /* Check when token is removed from local storage */
      const itemToCheck = '_prly_tk';
      window.addEventListener('storage', (event) => {
        if (event.key === itemToCheck) {
          if (event.newValue === null) {
            setTimeout(() => {
              Vue.router.go('login');
              window.HelpCrunch('logout');
              localStorage.clear();
              window.location.href = `https://parlay-ui-staging.herokuapp.com/account/login`;
            }, 2000);
            
          }
        }
      });
      EventBus.$on('openToast', (value) => {
        if (value === true) {
          this.isOpenToastDemo = true;
        }
        setTimeout(() => {
          this.isOpenToastDemo = false;
        }, 3000);
      });
      EventBus.$on('createToast', this.createToast);
      EventBus.$on('open-upgrade-modal', (text, studentReport) => {
        this.text = text;
        this.studentReport = studentReport;
        this.show_upgrade_modal = true;
      });
      EventBus.$on('open-upgrade-success-modal', () => {
        this.show_upgrade_success_modal = true;
      });
      // if you get rid of this, you have to make sure lets go modal uses a create course action
      EventBus.$on('createCourse', this.createCourse);
      EventBus.$on('toast-msg', this.fireToast);
      EventBus.$on('show-membership-invalid-modal', () => {
        this.show_membership_invalid_modal = true;
      });
      EventBus.$on('show_signup_error_toast', () => {
        this.show_signup_error_toast = true;
      });
      EventBus.$on('alert-msg', (msg) => {
        this.alert_message = msg;
        this.alert_show = true;
      });
      // use this eventbus in the dashboard for creating course
      EventBus.$on('open-new-course-modal', () => {
        this.show_create_course_modal = true;
      });
      EventBus.$on('open-join-course-modal', () => {
        this.show_join_roundtable_modal = true;
      });
      EventBus.$on('initialize-app', this.initializeApp);
      EventBus.$on(
        'school_admin_users',
        (data) => (this.adminUsersOfSchool = data)
      );
      EventBus.$on(
        'school_email_suffixes',
        (data) => (this.emailSuffixesOfSchool = data)
      );
      EventBus.$on('role-has-changed', () => {
        this.show_role_changed_modal = true;
      });
      EventBus.$on('removed_student_from_school', () => {
        this.show_removed_student_from_school_modal = true;
      });
      EventBus.$on('removed_course_from_school', () => {
        this.show_removed_student_from_school_modal = true;
        this.deleteCourse = true;
      });
      EventBus.$on('show-school-courses-modal', (school) => {
        this.show_school_courses_modal = true;
        this.upgraded_school = school;
      });
      EventBus.$on('upgradeSuccess', () => {
        this.show_upgrade_success_modal = true;
      });
      EventBus.$on('gradesGoogleSyncJob', (payload) => {
        this.gradesGoogleSyncJob(payload);
      });
      EventBus.$on('gradesEdlinkSyncJob', (payload) => {
        this.gradesEdlinkSyncJob(payload);
      });
      EventBus.$on('connectIntegrationAccount', (integration) => {
        this.account_integration = integration;
        this.show_connect_integration_account_modal = true;
      });
      EventBus.$on('open-welcome-modal', () => {
        this.show_welcome_modal = true;
      });
    },
    beforeDestroy() {
      EventBus.$off('createCourse');
      EventBus.$off('school_admin_users');
      EventBus.$off('school_admin_users');
      EventBus.$off('initialize-app');
      EventBus.$off('show-membership-invalid-modal');
      EventBus.$off('open-new-course-modal');
      EventBus.$off('open-join-course-modal');
      EventBus.$off('open-upgrade-success-modal');
      EventBus.$off('open-upgrade-modal');
      EventBus.$off('role-has-changed');
      EventBus.$off('school_email_suffixes');
      EventBus.$off('show-school-courses-modal');
      EventBus.$off('upgradeSuccess');
      EventBus.$off('removed_student_from_school');
      EventBus.$off('removed_course_from_school');
      EventBus.$off('connectIntegrationAccount');
      EventBus.$off('createToast');
      EventBus.$off('open-welcome-modal');
      window.removeEventListener('offline');
      window.removeEventListener('online');
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .pl-secondary
    color:pl-secondary
  .toast-message
    position: fixed
    background-color: #323232
    color: #fff
    min-width: 288px
    max-width: 450px
    min-height: 60px
    // max-height: 100px
    z-index: 9999
    border-radius: 6px
    margin: 0 auto
    padding: 15px
    right: 0
    top: -110px
    left: 0
    transition: all .5s ease
  #alert-message
    position: fixed
    background-color: #ed5555
    color: #fff
    font-weight: 500
    min-width: 288px
    max-width: 450px
    min-height: 60px
    max-height: 100px
    z-index: 9999
    border-radius: 6px
    margin: 0 auto
    padding: 10px
    right: 0
    top: -100px
    left: 0
    transition: all .5s ease
  .active
    transform: translateY(121.35px)
    transition: transform .5s ease
  .no-internet-connection
    height: 100vh;
    z-index: 10000
    background-color: gray
</style>
<style src="./tachyons.css"></style>



// WEBPACK FOOTER //
// index.vue?6ab36ad2